import starterImg from "@src/shared/assets/basic_images.svg";
import teamImg from "@src/shared/assets/team_img.svg";
import businessImg from "@src/shared/assets/case_tariff.svg";
import corporateImg from "@src/shared/assets/corporative_img.svg";

import styles from "./TariffCard.module.scss";

const dictionaryImages = {
  START: (
    <div className={styles.imgWrapper}>
      <img src={starterImg} className={styles.basicImg} alt="" />
    </div>
  ),
  TEAM: (
    <div className={styles.imgWrapper}>
      <img src={teamImg} className={styles.teamImg} alt="" />
    </div>
  ),
  BUSINESS: (
    <div className={styles.imgWrapper}>
      <img src={businessImg} className={styles.businessImg} alt="" />
    </div>
  ),
  CORPORATE: (
    <div className={styles.imgWrapper}>
      <img src={corporateImg} className={styles.corporativeImg} alt="" />
    </div>
  ),
};

export const dictionaryNamesTariffs = {
  START: {
    title: "Стартовый",
    text: "Идеально подходит для новичков в использовании сервиса",
    period: 30,
    order: 1,
    usersText: "1 пользователь",
    isRecommended: false,
  },
  TEAM: {
    title: "Командный",
    text: "Для совместной работы (до 5 пользователей)",
    period: 60,
    order: 2,
    usersText: "До 5 учетных записей",
    isRecommended: false,
  },
  BUSINESS: {
    title: "Бизнес",
    text: "Для команд с активным наймом",
    period: 90,
    order: 3,
    usersText: "До 5 учетных записей",
    isRecommended: true,
  },
  CORPORATE: {
    title: "Корпоративный",
    text: "Для крупных компаний с высоким объемом найма",
    period: 180,
    order: 4,
    usersText: "До 5 учетных записей",
    isRecommended: false,
  },
  FREE_TRIAL: {
    title: "Пробный",
    text: "-",
    period: 30,
    order: 5,
    usersText: "-",
    isRecommended: false,
  },
};

export type IImage = keyof typeof dictionaryImages;
export type INamesTariffs = keyof typeof dictionaryNamesTariffs;

export const getImages = (name: IImage) => dictionaryImages[name];

export function getRequestsWord(count: number): string {
  const lastTwo = count % 100;
  const lastOne = count % 10;

  if (lastTwo >= 11 && lastTwo <= 14) {
    return `${count} запросов`;
  }

  switch (lastOne) {
    case 1:
      return `${count} запрос`;
    case 2:
    case 3:
    case 4:
      return `${count} запроса`;
    default:
      return `${count} запросов`;
  }
}

export function getAttemptsWord(count: number): string {
  const lastTwo = count % 100;
  const lastOne = count % 10;

  if (lastTwo >= 11 && lastTwo <= 14) {
    return `${count} попыток`;
  }

  switch (lastOne) {
    case 1:
      return `${count} попытка`;
    case 2:
    case 3:
    case 4:
      return `${count} попытки`;
    default:
      return `${count} попыток`;
  }
}
